import React, { useState, useEffect } from 'react';
import { supabase } from '../../../utils/supabaseClient';
import NewsForm from '../newsForm/newsForm';
import {News} from "../../../utils/types";

const NewsManagement: React.FC = () => {
    const [newsList, setNewsList] = useState<News[]>([]);
    const [editingNews, setEditingNews] = useState<News | null>(null);

    useEffect(() => {
        fetchNews();
    }, []);

    const fetchNews = async () => {
        const { data, error } = await supabase.from('news').select('*');

        if (error) {
            console.error('Error fetching news:', error.message);
        } else {
            setNewsList(data);
        }
    };

    const handleDelete = async (id: number) => {
        const { error } = await supabase.from('news').delete().eq('id', id);

        if (error) {
            console.error('Error deleting news:', error.message);
            alert('Error deleting news');
        } else {
            fetchNews();
        }
    };

    const handleSave = () => {
        setEditingNews(null);
        fetchNews();
    };

    return (
        <div>
            <h1>News Management</h1>
            <button onClick={() => setEditingNews(null)}>Create New News</button>
            {editingNews && (
                <NewsForm news={editingNews} onSave={handleSave} />
            )}
            {!editingNews && (
                <NewsForm onSave={handleSave} />
            )}
            <h2>News List</h2>
            <ul>
                {newsList.map((news) => (
                    <li key={news.id}>
                        <h3>{news.title}</h3>
                        {news.content && (
                        <p dangerouslySetInnerHTML={{ __html: news.content }}></p>
                        )}
                        {news.image && (
                            <img
                                src={`https://heocxyrunuvilpdfnoib.supabase.co/storage/v1/object/public/news-images/${news.image}`}
                                alt={news.title}
                                style={{ width: '100px' }}
                            />
                        )}
                        <p>Category: {news.category}</p>
                        <button onClick={() => setEditingNews(news)}>Edit</button>
                        <button onClick={() => handleDelete(news.id)}>Delete</button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default NewsManagement;
